// The gateway in front of the API stops waiting after 30 seconds and answers 503 with no error of
// ours, while the airline check behind it runs on. Some bookings take longer than that on every try
// (PLT3016285: 36-42 seconds), so ops are told the check was slow, not that it failed. The
// Refunds and the Change and Cancellation screens both use it, so the advice fits a cancel and a change.
const GATEWAY_GAVE_UP = [503, 504]

export function refundQuoteFailureMessage(status: number, error: string | undefined): string {
  if (error) return error

  if (GATEWAY_GAVE_UP.includes(status)) {
    return 'The airline system took longer than 30 seconds to answer. Try again in a minute. If it times out again, handle this booking manually.'
  }

  return 'Failed to fetch refund quote'
}
